import { inject, provide } from 'vue';

import type { NTable } from '../interface';
import type { InjectionKey } from 'vue';

export interface IBodyContextProps<RecordType = NTable.TDefaultRecord> {
  rowClassName?: string | NTable.NRow.TClassName<RecordType>;
  expandedRowClassName?: NTable.NRow.TClassName<RecordType>;
  columns: NTable.NColumn.TColumns<RecordType>;
  flattenColumns: readonly NTable.NColumn.IColumn<RecordType>[];
  tableLayout: NTable.TLayout;
  indentSize: number;
  expandableType: NTable.NExpand.TExpandableType;
  expandRowByClick?: boolean;
  expandedRowRender?: NTable.NExpand.TExpandedRowRender<RecordType>;
  expandIconColumnIndex?: number;
  expandIcon: NTable.NExpand.TRenderExpandIcon<RecordType>;
  onTriggerExpand: NTable.TTriggerEventHandler<RecordType>;
}

export const BodyContextKey: InjectionKey<IBodyContextProps> = Symbol('cds:table:body');

export const useProvideBody = (props: IBodyContextProps) => {
  provide(BodyContextKey, props);
};

export const useInjectBody = () => {
  return inject(BodyContextKey, {} as IBodyContextProps);
};
